// src/components/Loading.js
import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Spinner animation="border" />
        </div>
    );
}

export default Loading;
